/**
 * This file was auto-generated by Fern from our API Definition.
 */
export const EventTopic = {
    AgentCreated: "agent:created",
    AgentUpdated: "agent:updated",
    AgentDeleted: "agent:deleted",
    SpaceCreated: "space:created",
    SpaceUpdated: "space:updated",
    SpaceDeleted: "space:deleted",
    SpaceArchived: "space:archived",
    SpaceUnarchived: "space:unarchived",
    SpaceExpired: "space:expired",
    SpaceGuestAdded: "space:guestAdded",
    SpaceGuestRemoved: "space:guestRemoved",
    DocumentCreated: "document:created",
    DocumentUpdated: "document:updated",
    DocumentDeleted: "document:deleted",
    WorkbookCreated: "workbook:created",
    WorkbookUpdated: "workbook:updated",
    WorkbookDeleted: "workbook:deleted",
    WorkbookExpired: "workbook:expired",
    WorkbookThawed: "workbook:thawed",
    FlagCreated: "flag:created",
    FlagUpdated: "flag:updated",
    FlagDeleted: "flag:deleted",
    SheetCreated: "sheet:created",
    SheetUpdated: "sheet:updated",
    SheetDeleted: "sheet:deleted",
    SheetCountsUpdated: "sheet:counts-updated",
    SheetCalculationUpdated: "sheet:calculation-updated",
    SnapshotCreated: "snapshot:created",
    RecordsCreated: "records:created",
    RecordsUpdated: "records:updated",
    RecordsDeleted: "records:deleted",
    FileCreated: "file:created",
    FileUpdated: "file:updated",
    FileDeleted: "file:deleted",
    FileExpired: "file:expired",
    JobCreated: "job:created",
    JobUpdated: "job:updated",
    JobDeleted: "job:deleted",
    JobCompleted: "job:completed",
    JobReady: "job:ready",
    JobScheduled: "job:scheduled",
    JobOutcomeAcknowledged: "job:outcome-acknowledged",
    JobPartsCompleted: "job:parts-completed",
    JobFailed: "job:failed",
    ProgramCreated: "program:created",
    ProgramUpdated: "program:updated",
    ProgramRecomputing: "program:recomputing",
    ProgramRecomputed: "program:recomputed",
    CommitCreated: "commit:created",
    CommitUpdated: "commit:updated",
    CommitCompleted: "commit:completed",
    LayerCreated: "layer:created",
    SecretCreated: "secret:created",
    SecretUpdated: "secret:updated",
    SecretDeleted: "secret:deleted",
    Cron5Minutes: "cron:5-minutes",
    CronHourly: "cron:hourly",
    CronDaily: "cron:daily",
    CronWeekly: "cron:weekly",
    EnvironmentCreated: "environment:created",
    EnvironmentUpdated: "environment:updated",
    EnvironmentDeleted: "environment:deleted",
    EnvironmentAutobuildCreated: "environment:autobuild-created",
    ActionCreated: "action:created",
    ActionUpdated: "action:updated",
    ActionDeleted: "action:deleted",
    DataClipCreated: "data-clip:created",
    DataClipUpdated: "data-clip:updated",
    DataClipDeleted: "data-clip:deleted",
    DataClipCollaboratorUpdated: "data-clip:collaborator-updated",
    DataClipResolutionsCreated: "data-clip:resolutions-created",
    DataClipResolutionsUpdated: "data-clip:resolutions-updated",
    DataClipResolutionsRefreshed: "data-clip:resolutions-refreshed",
    CanvasCreated: "canvas:created",
    CanvasUpdated: "canvas:updated",
    CanvasDeleted: "canvas:deleted",
    CanvasAreaCreated: "canvas-area:created",
    CanvasAreaUpdated: "canvas-area:updated",
    CanvasAreaDeleted: "canvas-area:deleted",
    ThreadCreated: "thread:created",
    ThreadUpdated: "thread:updated",
    ThreadDeleted: "thread:deleted",
};
